<style lang="less" scoped>
  @import '../../../style/common/variable';
  .swiperGroup{position: relative;width:1170px;overflow:hidden;}
  .seamless-warp{width: 1200px;height: 180px;overflow: hidden;}
  ul{list-style: none;display: flex;}
  li{width: 158px;height:152px;overflow: hidden;margin: 0px 10px;cursor: pointer;}
  li:hover .title{color:#13569e;}
  img{width:158px;height:122px;transition: transform .5s;}
  img:hover {transform: scale(1.2,1.2)}
  .title {width: 150px;font-size: 14px;margin-top: 5px;text-align: left;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .swiperGroup{position: relative;width:1170px;overflow:hidden;}
  .seamless-warp{width: 1200px;height: 180px;overflow: hidden;}
  ul{list-style: none;display: flex;}
  li{width: 158px;height:152px;overflow: hidden;margin: 0px 10px;cursor: pointer;}
  li:hover .title{color:#13569e;}
  img{width:158px;height:122px;transition: transform .5s;}
  img:hover {transform: scale(1.2,1.2)}
  .title {width: 150px;font-size: 14px;margin-top: 5px;text-align: left;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  @media screen and (max-width: @max-screen) {
    .swiperGroup{margin-left: 2vw; width: 96vw;}
  }
</style>

<!-- 何宽 2021.7.13
     该组件使用场景：自动轮播一组图片，点击 图片或 图片文本内容，将 整个对象 传递给父组件 -->
<template>
  <div class="swiperGroup">
    <vue-seamless-scroll :data="swiperGroupList" class="seamless-warp" :class-option="optionLeft">
      <ul>
        <li class="DataList_left" v-for="(item,index) in swiperGroupList" :key="index" @click="clickSwiper(item)">
          <img class="pic" :src="item.pic" />
          <span class="title"> {{ item.title }} </span>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  props: ['swiperGroupList'],
  components:
  {
    vueSeamlessScroll
  },
  data()
  {
    return {
    }
  },
  computed:
  {
    optionLeft()
    {
      return {
        step: 0.8,
        direction: 2
      }
    }
  },
  // 点击图片或图片标题，将该图片对象传递给父组件
  methods: {
    clickSwiper(item)
    {
      this.$emit('clickSwiper', item)
    }
  }
}
</script>
<!--  父组件需要传递的 参数 及 数据格式
swiperGroupList: [
  {
    id: '',
    pic: 'static/img/中心足迹/1.png',
    title: '“中国—东盟地学合作中心东盟学院”成立',
  }
]
-->



// WEBPACK FOOTER //
// src/plugins/app/assembly/SwiperGroup.vue